import dayjs from "dayjs";

export const validatePricingTier = (values) => {
  const errors = {};
  if (
    values.minQty &&
    values.maxQty &&
    parseInt(values.minQty, 10) > parseInt(values.maxQty, 10)
  ) {
    errors.minQty = "Min Qty can't exceed Max Qty";
    errors.maxQty = "Max Qty can't be less than Min Qty";

  }

  if (
    values.startDate &&
    values.endDate &&
    dayjs(values.endDate).isBefore(dayjs(values.startDate))
  ) {
    errors.endDate = "End date can't be before start date";
  }

  return errors;
};
